/**
 * Shop rarity — presentation only, read off the price (the meta layer has no rarity field): what you pay in keys is
 * legendary, the dearer SOL items epic, then rare, the cheapest common. Drives the card frame colour and the tag.
 */
export type Rarity = "common" | "rare" | "epic" | "legendary";

export const rarityLabel: Record<Rarity, string> = { common: "COMMON", rare: "RARE", epic: "EPIC", legendary: "LEGENDARY" };

/** Roadster paint jobs: SOL prices 0 – 3,000, key prices 30 – 60. */
export function skinRarity(item: { price: number; keys?: number }): Rarity {
  if (item.keys) return "legendary";
  if (item.price >= 2500) return "epic";
  if (item.price >= 1000) return "rare";
  return "common";
}

/** Hover boards: SOL prices 0 – 30,000, key prices 50 – 80. */
export function boardRarity(item: { price: number; keys?: number }): Rarity {
  if (item.keys) return "legendary";
  if (item.price >= 25000) return "epic";
  if (item.price > 0) return "rare";
  return "common";
}
